import { lazyImport } from 'utils/lazyImport';
import { Navigate } from 'react-router';

const { AuthenticationRoutes } = lazyImport(
  () => import('features/authentication'),
  'AuthenticationRoutes'
);

export const publicRoutes = [
  {
    path: '/auth/*',
    element: <AuthenticationRoutes />,
  },
  { path: '*', element: <Navigate to="." /> },
];
